module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-repeat-372b6a58.svg";